import { Chevrone as IconChevrone } from 'education-icons';
import { Link, type LinkProps } from 'platform-components';
import React, { ReactNode } from 'react';

import './breadcrumb__link.scss';

interface Props {
    to: LinkProps['to'];
    isRouter?: LinkProps['isRouter'];
    children: ReactNode;
}

export const LibraryBreadcrumbLink = ({ children, to, isRouter = true }: Props) => (
    <Link isRouter={isRouter} mix="library-breadcrumb__link" theme={Link.THEME.STEALTHY} to={to}>
        <IconChevrone />
        {children}
    </Link>
);
